export function initTextareaAutoResize() {
    document.querySelectorAll('textarea.form-input-auto').forEach(function (textarea) {
        if (textarea.dataset.autoInitialized) return;
        textarea.dataset.autoInitialized = 'true';

        function resize() {
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
        }

        textarea.addEventListener('input', resize);
        resize();
    });
}

export function initTextareaManualResize() {
    document.querySelectorAll('textarea.form-control').forEach(function (textarea) {
        if (textarea.dataset.resizeInitialized) return;
        textarea.dataset.resizeInitialized = 'true';

        const startResize = (e) => {
            const rect = textarea.getBoundingClientRect();
            const isTouch = e.type === 'touchstart';
            const clientX = isTouch ? e.touches[0].clientX : e.clientX;
            const clientY = isTouch ? e.touches[0].clientY : e.clientY;
            
            const handleSize = 32;
            const inResizeArea = (
                clientX >= rect.right - handleSize &&
                clientY >= rect.bottom - handleSize
            );

            if (!inResizeArea) return;

            e.preventDefault();

            const startX = clientX;
            const startY = clientY;
            const startWidth = rect.width;
            const startHeight = rect.height;

            const onMove = (moveEvent) => {
                const moveClientX = isTouch ? moveEvent.touches[0].clientX : moveEvent.clientX;
                const moveClientY = isTouch ? moveEvent.touches[0].clientY : moveEvent.clientY;

                const newWidth = startWidth + (moveClientX - startX);
                const newHeight = startHeight + (moveClientY - startY);

                textarea.style.height = `${newHeight}px`;
            };

            const onEnd = () => {
                document.removeEventListener(isTouch ? 'touchmove' : 'mousemove', onMove);
                document.removeEventListener(isTouch ? 'touchend' : 'mouseup', onEnd);
            };

            document.addEventListener(isTouch ? 'touchmove' : 'mousemove', onMove, { passive: false });
            document.addEventListener(isTouch ? 'touchend' : 'mouseup', onEnd);
        };

        textarea.addEventListener('mousedown', startResize);
        textarea.addEventListener('touchstart', startResize, { passive: false });
    });
}
